<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('menu.containerTypeMaintain')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{ span: 8 }" :model="data" :rules="rules" :wrapper-col="{ span: 16 }">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.no')" prop="no">
            <vxe-input v-model="data.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.name')" prop="name">
            <vxe-input v-model="data.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.codeInitial')">
            <vxe-input v-model="data.codeInitial" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.codeLength')">
            <vxe-number-input v-model="data.codeLength" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.length')" prop="dimension.length">
            <vxe-number-input v-model="data.dimension.length" :min="0" :suffixConfig="{content:$t('col.uomOfDimension')}" style="width: 100%" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.width')" prop="dimension.width">
            <vxe-number-input v-model="data.dimension.width" :min="0" :suffixConfig="{content:$t('col.uomOfDimension')}" style="width: 100%" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.height')" prop="dimension.height">
            <vxe-number-input v-model="data.dimension.height" :min="0" :suffixConfig="{content:$t('col.uomOfDimension')}" style="width: 100%" @change="onDimensionChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.volume')" prop="dimension.volume">
            <vxe-number-input v-model="data.dimension.volume" :min="0" :suffixConfig="{content:$t('col.uomOfVolume')}" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.weight')">
            <vxe-number-input v-model="data.weight" :min="0" :suffixConfig="{content:$t('col.uomOfWeight')}" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.halfVolume')">
            <vxe-number-input v-model="data.halfVolume" :min="0" :suffixConfig="{content:$t('col.uomOfWeight')}" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.physical')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.physical"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.goback')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.goback"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.sendingErp')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.sendingErp"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { ContainerType } from '@/api/dto/common/ContainerType'

export default {
  name: 'ContainerTypeEditor',
  props: {
    dataSources: { type: Array, default: [] },
    shapes: { type: Array, default: [] }
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      data: new ContainerType(),
      rules: {
        no: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.length': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.width': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.height': [{ required: true, message: this.$t('message.cannotBeEmpty') }],
        'dimension.volume': [{ required: true, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    onDimensionChange() {
      this.data.dimension.volume = this.data.dimension.length * this.data.dimension.width * this.data.dimension.height
    },
    add() {
      this.visible = true
      this.data = new ContainerType()
      this.data.available = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('containerTypeFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new ContainerType(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      data.enterprise = this.enterprise
      save('containerTypePersister', data).then(res => {
        if (res.success) {
          this.data = new ContainerType(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>